<xcm-metagroup-list [metagroups]="metagroups$ | async" (onDetails)="details($event)" ></xcm-metagroup-list>